<template>
<div>
    <div class="md-layout">
        <div class="md-layout-item md-size-50 md-xsmall-size-100 md-size-25">
            <stats-card header-color="blue" @click.native="type('Frota')">
                <template slot="header">
                    <div class="card-icon">
                        <i class="fas fa-gas-pump"></i>
                    </div>
                    <h2 class="title text-secondary md-toolbar-section-start">
                        FROTA
                    </h2>
                </template>
            </stats-card>
        </div>
        <div class="md-layout-item md-size-50 md-xsmall-size-100 md-size-25">
            <stats-card header-color="danger" @click.native="type('Convênio')">
                <template slot="header">
                    <div class="card-icon">
                        <i class="fas fa-shopping-bag"></i>
                    </div>
                    <h2 class="title text-secondary md-toolbar-section-start">
                        CONVÊNIO
                    </h2>
                </template>
            </stats-card>
        </div>
    </div>

    <md-card v-show="frota">
        <header-form title="LOCALIZAR CARRO" :btnHide="true" />
        <md-card-content>
            <div class="md-layout">
                <div class="md-layout-item md-size-20 md-xsmall-size-100">
                    <md-field :class="{ 'md-error': errors.placa_matricula }">
                        <label>MATRÍCULA OU PLACA:</label>
                        <md-input v-model="dados.placa_matricula" type="text" class="pagamento"> </md-input>
                        <slide-y-down-transition>
                            <md-icon class="error" v-show="errors.placa_matricula">close</md-icon>
                        </slide-y-down-transition>
                    </md-field>
                    <div v-if="errors.placa_matricula" class="validErro"> {{ errors.placa_matricula[0] }}</div>
                </div>

                <div class="md-layout-item md-size-15 md-xsmall-size-100">
                    <md-button @click="getCarro" class="md-site md-round md-block">
                        <span class="md-label">
                            <md-icon class="material-icons">search</md-icon>
                        </span>BUSCAR
                    </md-button>
                </div>
            </div>
            <div v-if="message" class="alert alert-danger" style="padding: 1px 15px">
                <h4> {{message}} </h4>
            </div>
        </md-card-content>
    </md-card>

    <md-card v-show="convenio">
        <header-form title="LOCALIZAR CLIENTE" :btnHide="true" color="md-card-header-danger" />
        <md-card-content>
            <div class="md-layout">
                <div class="md-layout-item md-size-20 md-xsmall-size-100">
                    <md-field :class="{ 'md-error': errors.cpf_cnpj }">
                        <label>CPF OU CNPJ:</label>
                        <md-input v-model="dados.cpf_cnpj" type="text" class="pagamento" v-mask="['###.###.###-##', '##.###.###/####-##']"> </md-input>
                        <slide-y-down-transition>
                            <md-icon class="error" v-show="errors.cpf_cnpj">close</md-icon>
                        </slide-y-down-transition>
                    </md-field>
                    <div v-if="errors.cpf_cnpj" class="validErro"> {{ errors.cpf_cnpj[0] }}</div>
                </div>

                <div class="md-layout-item md-size-15 md-xsmall-size-100">
                    <md-button @click="getCliente" class="md-danger md-round md-block">
                        <span class="md-label">
                            <md-icon class="material-icons">search</md-icon>
                        </span>BUSCAR
                    </md-button>
                </div>
            </div>
            <div v-if="message" class="alert alert-danger" style="padding: 1px 15px">
                <h4> {{message}} </h4>
            </div>
        </md-card-content>
    </md-card>

    <md-card v-show="isPagamento">
        <header-form v-if="isParcela" title="CADASTRAR PAGAMENTO DE CONVÊNIO" :btnHide="true" color="md-card-header-danger" />
        <header-form v-else title="CADASTRAR PAGAMENTO DE FROTA" :btnHide="true" />

        <md-card-content>
            <div class="md-layout">
                <div class="md-layout-item md-size-30 md-xsmall-size-100 uppercase" style="margin-top: -15px">
                    <h4>NOME:</h4>
                    <h4 class="text-label"><strong class="text-secondary">{{ cliente.nome }}</strong></h4>
                </div>

                <div class="md-layout-item md-size-55 md-xsmall-size-100 uppercase" style="margin-top: -15px">
                    <h4>EMPRESA:</h4>
                    <h4 class="text-label"><strong class="text-secondary">{{ cliente.empresa }}</strong></h4>
                </div>

                <div class="md-layout-item md-size-15 md-xsmall-size-100 uppercase" style="margin-top: -15px">
                    <h4>LIMITE:</h4>
                    <h4 class="text-label"><strong class="text-secondary">{{ cliente.limite_disponivel }}</strong></h4>
                </div>
            </div>

            <div class="md-layout">
                <div class="md-layout-item md-size-25 md-xsmall-size-100">
                    <md-field :class="{ 'md-error': errors.valor }">
                        <label>VALOR</label>
                        <md-input v-model="dados.valor" type="text" class="pagamento" v-money> </md-input>
                        <slide-y-down-transition>
                            <md-icon class="error" v-show="errors.valor">close</md-icon>
                        </slide-y-down-transition>
                    </md-field>
                    <div v-if="errors.valor" class="validErro"> {{ errors.valor[0] }}</div>
                </div>

                <div v-if="isParcela" class="md-layout-item md-size-25 md-xsmall-size-100">
                    <md-field :class="{ 'md-error': errors.parcelas }">
                        <label>PARCELAS</label>
                        <md-select v-model="dados.parcelas" name="pages">
                            <md-option v-for="item in parcelas" :key="item" :value="item">
                                {{ item }}
                            </md-option>
                        </md-select>
                        <slide-y-down-transition>
                            <md-icon class="error" v-show="errors.parcelas">close</md-icon>
                        </slide-y-down-transition>
                    </md-field>
                    <div v-if="errors.parcelas" class="validErro"> {{ errors.parcelas[0] }}</div>
                </div>

                <div v-if="!isParcela" class="md-layout-item md-size-25 md-xsmall-size-100">
                    <md-field :class="{ 'md-error': errors.matricula }">
                        <label>MATRICULA</label>
                        <md-input v-model="dados.matricula" type="text" class="pagamento"> </md-input>
                        <slide-y-down-transition>
                            <md-icon class="error" v-show="errors.matricula">close</md-icon>
                        </slide-y-down-transition>
                    </md-field>
                    <div v-if="errors.matricula" class="validErro"> {{ errors.matricula[0] }}</div>
                </div>

                <div class="md-layout-item md-size-25 md-xsmall-size-100">
                    <md-field :class="{ 'md-error': errors.password }">
                        <label>SENHA</label>
                        <md-input v-model="dados.password" type="password" class="pagamento" v-mask="['######']"> </md-input>
                        <slide-y-down-transition>
                            <md-icon class="error">close</md-icon>
                        </slide-y-down-transition>
                    </md-field>
                    <div v-if="errors.password" class="validErro"> {{ errors.password[0] }}</div>
                </div>

                <div class="md-layout-item md-size-25 md-xsmall-size-100">
                    <md-button @click="create" class="md-site md-round md-block" :class="[{'md-danger': isParcela}]" :disabled="loading">
                        <span class="md-label">
                            <md-icon class="material-icons">shopping_basket</md-icon>
                        </span>COMPRAR
                    </md-button>
                </div>
            </div>
            <div v-if="message" class="alert alert-danger" style="padding: 1px 15px">
                <h4> {{message}} </h4>
            </div>
        </md-card-content>
    </md-card>

</div>
</template>

<script>
import Notify from '@/config/mixins/notify'
import HeaderForm from '@/pages/Layout/Extra/HeaderForm'
import preLoader from '@/config/mixins/preLoader';
import Pagamento from '@/config/mixins/print/pagamento'
import {
    StatsCard
} from "@/components";

export default {
    components: {
        HeaderForm,
        StatsCard,
    },
    data() {
        return {
            dados: {
                parcelas: 1,
                matricula: null,
                cpf_cnpj: null
            },
            cliente: {},
            parcelas: [],
            message: null,
            errors: {},
            isVisible: true,
            convenio: false,
            frota: false,
            isPagamento: false,
            isParcela: false,
            loading: false
        }
    },
    mixins: [Notify, preLoader, Pagamento],

    created () {
        this.authorize();
    },
    
    methods: {
        authorize() {
            this.$http.get(this.$urlAPI + 'autorizado')
                .then(response => {

                })
                .catch(e => {
                    this.msgErrors(e)
                })
        },

        type(text) {
            //  this.dados = {}
            this.message = null
            if (text === 'Frota') {
                this.typeFrota()
            } else {
                this.typeConvenio()
            }
        },

        typeFrota() {
            if (this.frota) {
                this.frota = false
                this.convenio = false
                this.isPagamento = false
                this.isParcela = false
            } else {
                this.frota = true
                this.convenio = false
                this.isPagamento = false
                this.isParcela = false
            }
        },

        typeConvenio() {
            if (this.convenio) {
                this.convenio = false
                this.frota = false
                this.isPagamento = false
                this.isParcela = true
            } else {
                this.convenio = true
                this.frota = false
                this.isPagamento = false
                this.isParcela = true
            }
        },

        getCliente() {
            let loader = this.openLoader('dots');
            this.dados.frota = false
            this.$http.post(this.$urlAPI + 'pagamentos/buscar', this.dados)
                .then(response => {
                    if (response.data.status) {
                        this.cliente = response.data.dados[0];
                        this.errors = ''
                        this.message = null
                        this.convenio = false
                        this.frota = false
                        this.isPagamento = true
                        this.numParcelas(this.cliente.num_parcela_id)
                    } else if (response.data.errors) {
                        this.errors = response.data.errors
                    } else {
                        this.message = response.data.message;
                        this.errors = ''
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
                .finally(function () {
                    loader.hide();
                });
        },

        getCarro() {
            let loader = this.openLoader('dots');
            this.dados.frota = true
            this.dados.parcelas = 1
            this.$http.post(this.$urlAPI + 'pagamentos/buscar', this.dados)
                .then(response => {
                    if (response.data.status) {
                        this.cliente = response.data.dados[0];
                        this.errors = ''
                        this.message = null
                        this.convenio = false
                        this.frota = false
                        this.isPagamento = true
                        this.numParcelas(this.cliente.num_parcela_id)
                    } else if (response.data.errors) {
                        this.errors = response.data.errors
                    } else {
                        this.message = response.data.message;
                        this.errors = ''
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
                .finally(function () {
                    loader.hide();
                });
        },

        numParcelas(parcela) {
            let parcelas = []
            for (let i = 1; i < parcela + 1; i++) {
                parcelas.push(i);
            }
            this.parcelas = parcelas;
        },

        create() {
            this.loading = true 
            this.dados.cliente_id = this.cliente.id;
            this.dados.empresa_id = this.cliente.empresa_id;
            this.$http.post(this.$urlAPI + 'pagamentos', this.dados)
                .then(response => {
                    if (response.data.status) {
                        this.pagamento(response.data.dados)
                        this.dados = {};
                        this.dados.parcelas = 1;
                        this.isPagamento = false
                        this.success(response.data.message)
                        this.errors = ''
                        this.message = null
                    } else if (response.data.errors) {
                        this.errors = response.data.errors
                    } else {
                        this.message = response.data.message
                        this.errors = ''
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
                .finally(() => {
                    this.loading = false
                });
        },

        pagamento(dataComprovante) {
            this.printPagamento(dataComprovante[0])
        }
    }
};
</script>

<style>
.text-label {
    margin-top: -25px !important;
}

.md-toggle-password,
.error {
    visibility: hidden !important;
}
</style>
